<template>
    <div id="openAllHandWrite">
        <el-dialog
                title="打开板书"
                :visible.sync="show_dialog"
                width="80%"
                :modal-append-to-body="can_click_close"
                :append-to-body="!can_click_close"
                :close-on-click-modal="can_click_close"
                :before-close="handleClose">
            <div class="dialog-content-top">
                <div class="dialog-top">
                    <div class="save-to-position">
                        <span>板书日期</span>
                        <div class="dater-select class-list">
                            <!--                    <el-date-picker-->
                            <!--                        type="dates"-->
                            <!--                        v-model="select_date"-->
                            <!--                        value-format="yyyy-MM-dd"-->
                            <!--                        :picker-options="pickerOptions"-->
                            <!--                        placeholder="选择一个或多个日期" @change="change_date">-->
                            <!--                    </el-date-picker>-->
                            <dateCom @changeMonth="getNewDate" :resDate="file_date"></dateCom>
                        </div>
                    </div>
                    <div class="save-to-position">
                        <span>科目课时</span>
                        <!--                :isSave="true"-->
                        <selectCourse @selectCourse="selectCourseFun" :isOpen="true" :click-type="click_type"></selectCourse>
                    </div>
                    <div class="save-to-position">
                        <span>授课班级</span>
                        <div class="class-list" >
                            <span v-for="(item,index) in class_list" :key='index' :class="{'active':cur_class_id==item.id}" @click="change_class(item.id)">{{item.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="select-hand-write-img" v-if="teacher_bord_list.length>0">
                    <!--                <span>板书</span>-->
                    <div class="hand-write-img">
                        <div class="hand-box" v-for="(item,index) in teacher_bord_list" :key="index"  >
                            <p @click="hide_list(index)">{{item.date}}<span class="blue-text" @click.stop="hide_list(index)">{{hide_list_arr.includes(index)?'收起':'展开'}}</span><i :class="hide_list_arr.includes(index)?'icon-arrow-up':'icon-arrow-down'"></i></p>
                            <div class="hand-img-item-box">
                                <div class="hand-img-item"  v-show="hide_list_arr.includes(index)" v-for="(img_item,img_index) in item.list" :key="img_index" :class="{active:(cur_img_index==img_index && edit_bord_id==img_item.id)}" >
                                   <span class="share-bord"  @click="share_bord_fun(img_item,img_index,index)"><i :class="img_item.share_range_id=='1'?'is-share':'not-share'"></i><i>{{img_item.share_range_id=='1'?'取消分享':'分享'}}</i></span>
                                    <span class="del-bord" @click="del_bord_fun(img_item)"><i class="el-icon-delete"></i></span>
                                    <div class="hand-img-box" :style="getHandWriteBgStyle(img_item)" @click="choose_img_show(img_item,img_index,index)" @dblclick="db_choose_img_show(img_item,img_index,index)">
                                        <img :src="img_item.file_cdn_url" alt="" :style="{background:img_item.bg_color}">
                                    </div>
                                    <div class="hand-img-info">
                                        <span>{{img_item.title}}</span>
                                        <span class="icon-edit" @click="edit_name(img_item.title,img_item.id)"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dialog-pagination" v-if="teacher_bord_list.length>0 && total_page_count>1">
                        <p @click="add_page">加载更多</p>
                        <!--                <el-pagination-->
                        <!--                        background-->
                        <!--                        prev-text="上一页"-->
                        <!--                        next-text="下一页"-->
                        <!--                        layout="prev, pager, next"-->
                        <!--                        @current-change="change_cur_page"-->
                        <!--                        :page-size="10"-->
                        <!--                        :total="total_bord_num">-->
                        <!--                </el-pagination>-->
                    </div>
                </div>
                <div class="select-hand-write-img" v-else>
                    <!--                <span>板书</span>-->
                    <div class="hand-write-img no-data">
                        <span>当前课程暂无板书</span>
                    </div>
                </div>
            </div>
            <div class="dialog-bottom" >
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="sure_choose_img" size="small">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            class="edit-model"
            title="重命名"
            :visible.sync="is_edit_name"
            width="50%"
            :modal-append-to-body="can_click_close"
            :append-to-body="!can_click_close"
            :close-on-click-modal="can_click_close">
            <el-form :model="dynamicValidateForm" :rules="rules" label-position="left" ref="renameForm" label-width="100px" class="demo-dynamic">
                <el-form-item prop="title" label="板书名称" >
                    <el-input ref="renameInput" v-model="dynamicValidateForm.title" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item align="right">
                    <el-button @click="cancel_edit">取消</el-button>
                    <el-button type="primary" @click="sure_edit" >确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
<!--        @sureShare="sureShareFun"-->
        <shareHandWrite
            v-if="show_share_hand_write"
            :isSave="true"
            :classList="class_list"
            :itemId="edit_bord_id"
            @sureShare="sureShareFun"
        ></shareHandWrite>
    </div>
</template>

<script>
    import selectCourse from './selectCourse'
    // import dateCom from './date.vue'
    import dateCom from './date-new.vue'
    import shareHandWrite from "./shareHandWrite";
    import * as api from '../indexApi'
    export default {
        name: "openAllHandWrite",
        props:{

        },
        components:{
            selectCourse,//选择科目组件
            shareHandWrite,
            dateCom
        },
        data(){
            return{
                click_type:2,
                cur_img_index:null,
                list_index:null,
                is_push_course:false,//是否推送课程
                show_dialog:true,//是否显示对话框
                can_click_close:false,//点击遮罩层关闭
                hand_write_name:'',//板书名称
                curr_page_index:1,
                cur_select_course:sessionStorage.getItem('course')||'',//当前选择的课程
                root_subject_id:'',
                teacher_bord_list:[],
                total_bord_num:0,
                total_page_count:0,
                cur_select_course_info:{},
                select_course_obj:{},
                select_date:'',//选择的日期
                pickerOptions: {//快捷键日期
                    // disabledDate(time) {
                    //     return time.getTime() > Date.now();
                    // },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            let date =new Date() ;
                            let y = date.getFullYear();
                            let M = date.getMonth()+1;
                            let d = date.getDate();
                            let new_date = y+'-'+M+'-'+d ;
                            picker.$emit('pick', [new_date]);
                        }
                    },]
                },
                class_list:[],//班级列表
                cur_class_id:"",
                is_edit_name:false,
                edit_bord_id:'',
                dynamicValidateForm:{
                    title:''
                },
                rules: {
                    title: [
                        {
                            required: true,
                            message: "板书名称不能为空",
                            trigger: "blur",
                        },
                        {
                            max: 10,
                            message: "仅支持输入10个字符",
                            trigger: "blur",
                        },
                    ],
                },
                hide_list_arr:[],//
                show_list:true,
                show_share_hand_write:false,
                show_select_date:false,
                is_change_month:false,
                file_date:[],
                copy_edit_name:'',//复制板书名称
                cur_edit_name:'',//复制板书名称
            }
        },
        methods:{
            getHandWriteBgStyle(item) {
              const style = {};

              if (item.bg_color.toLowerCase().replace(/\s+/g, '') === 'rgba(255,255,255,0)' && item.bg_file_cdn_url != '') {
                style['background-image'] = `url(${item.bg_file_cdn_url})`;
              } else {
                style['background-color'] = item.bg_color;
              }

              return style;
            },
            formatTime(timestamp) {
                return this.format(timestamp, "yyyy-MM-dd");
            },
            getClass(){
                api.getClass({
                    root_subject_id:this.select_course_obj.root_subject_id||sessionStorage.getItem('root_subject')
                }).then((res)=>{
                    if(res.errCode==0){
                        this.class_list = _.cloneDeep(res.data);
                        this.class_list.unshift({
                            id:'',
                            name:'全部'
                        })
                    }
                }).catch(err=>{console.log(err)})
            },
            change_class(val){
                if(this.cur_class_id==val){
                    return;
                }
                this.cur_class_id = val;
                this.teacher_bord_list = [];
                this.curr_page_index =1;
                this.getTeacherBors()
            },
            //单点确认图片
            sure_choose_img(){
                if(this.cur_img_index!=null){
                    this.$emit('curImgUrl',this.teacher_bord_list[this.list_index].list[this.cur_img_index]);
                    // 选择板书flydata事件
                    this.$flydata.flydataTrack(113);
                    this.show_dialog = false;
                    return;
                }
                this.show_dialog = false;
            },
            db_choose_img_show(item,img_index,index){
                this.cur_img_index = img_index;
                this.edit_bord_id = item.id;
                this.$emit('curImgUrl',this.teacher_bord_list[index].list[this.cur_img_index]);
                // 选择板书flydata事件
                this.$flydata.flydataTrack(113);
                this.show_dialog = false;
            },
            //选择板书图片
            choose_img_show(item,img_index,index){
                if(this.cur_img_index==img_index&&this.edit_bord_id == item.id){
                    this.cur_img_index=null;
                    return;
                }
                this.cur_img_index = img_index;
                this.edit_bord_id = item.id;
                this.list_index = index;
            },
            //分享板书
            share_bord_fun(item,img_index,index){
                if(item.share_range_id=='1'){
                    this.$loading.show()
                    api.delShareBord({
                        // ids:[item.id],
                        id:item.id,
                    }).then((res)=>{
                        if(res.errCode==0){
                            this.$message({
                                message:'取消分享成功',
                                type:'success'
                            });
                            item.share_range_id = '0' ;
                            this.$loading.hide();
                        }
                    }).catch(err=>console.log(err))
                }else{
                    //保存时 为保存到班级或课程
                    if(!item.course_id || !item.class_id){
                        this.show_share_hand_write = true;
                        this.edit_bord_id = item.id;
                        this.cur_img_index = img_index;
                        this.list_index = index;
                    }else{
                        this.$loading.show()
                        api.teaShareBord({
                            id:item.id,
                            course_id:item.course_id,
                            class_ids:[item.class_id],
                        }).then((res)=>{
                            if(res.errCode==0){
                                this.$flydata.flydataTrack(72);
                                if(res.data.not_push_class_ids.length>0&&res.data.not_push_class_ids[0]!=''){
                                    let not_push_class = '' ;
                                    this.class_list.slice(1).forEach((class_item)=>{
                                        if(res.data.not_push_class_ids[0]==class_item.id){
                                            not_push_class += (class_item.name +'、')
                                        }
                                    });
                                    not_push_class = not_push_class.slice(0,-1)
                                    this.$message({
                                        message:`${not_push_class}该课未推送，学生可在推送后看到该板书`,
                                        type:'warning'
                                    });
                                }else{
                                    this.$message({
                                        message:'分享成功，学生可在【板书分享】看到该板书',
                                        type:'success'
                                    });
                                }
                                item.share_range_id = '1' ;
                                this.$loading.hide();
                                // this.teacher_bord_list = [];
                                // this.curr_page_index = 1;
                                // this.getTeacherBors();
                            }
                        }).catch(err=>console.log(err))
                    }
                }

            },
            //删除板书
            del_bord_fun(item){
                // this.$confirm("是否删除板书",'确认操作', {
                //     customClass: "akadm-modal akadm-confirm-box",
                //     confirmButtonText: "确定",
                //     ancelButtonText: "取消",
                // }).then(() => {
                    let _this= this ;
                    api.teaDelBord({
                        id:item.id
                    }).then((res)=>{
                        if(res.errCode==0){
                            _this.$message({
                                message:'删除板书成功',
                                type:'success'
                            });
                            _this.teacher_bord_list = [];
                            _this.curr_page_index = 1;
                            _this.getTeacherBors();
                        }
                    }).catch(err=>console.log(err))

                // }).catch(() => {
                //
                // });

            },
            //关闭保存弹窗
            handleClose() {
                this.show_dialog = false;
                this.$emit('close');
            },
            //修改改成回调
            selectCourseFun(val,status){
                this.select_course_obj = _.cloneDeep(val)
                this.cur_select_course_info = _.cloneDeep(val.subject_id);
                setTimeout(()=>{
                    if(!val.root_subject_id){
                        this.class_list=[{
                                id:'',
                                name:'全部'
                            }];
                        this.root_subject_id = val.root_subject_id ;
                        this.teacher_bord_list = [];
                        this.getTeacherBors();
                        return;
                    }
                    if(this.root_subject_id != val.root_subject_id ){
                        this.getClass();
                    }
                    this.root_subject_id = val.root_subject_id ;
                    this.teacher_bord_list = [];
                    this.getTeacherBors();
                },0)
            },
            //获取老师白板数据
            getTeacherBors(){
                // if(!this.select_course_obj.root_subject_id){
                //     return;
                // }
                this.$loading.show();
                api.getTeacherBors({
                    root_subject_id:this.select_course_obj.root_subject_id||sessionStorage.getItem('root_subject_id'),
                    second_subject_id:this.select_course_obj.second_subject_id||sessionStorage.getItem('second_subject_id'),
                    third_subject_id:this.select_course_obj.third_subject_id||sessionStorage.getItem('third_subject_id'),
                    course_id:this.select_course_obj.subject_id?this.select_course_obj.subject_id.id:'',
                    class_id:this.cur_class_id,
                    curr_page_index:this.curr_page_index,
                    dates:(this.select_date && this.select_date.length>0)?this.select_date:[],
                }).then((res)=>{
                    if(res.errCode==0){
                        this.total_bord_num = 0;
                        if(!res.data.list){
                            return ;
                        }
                        this.$loading.hide();

                        // this.teacher_bord_list = [...this.teacher_bord_list,..._.cloneDeep(res.data.list)];
                        // let total_list = [...this.teacher_bord_list,..._.cloneDeep(res.data.list)];
                        let total_list = _.cloneDeep(this.teacher_bord_list);
                        let bord_list = _.cloneDeep(res.data.list) ;
                        if(this.teacher_bord_list.length>0){
                            bord_list.forEach((item,index)=>{
                                total_list.forEach((e,e_index)=>{
                                    if(item.date==e.date){
                                        e.list = [...e.list,...item.list];
                                        bord_list.splice(index,1)
                                    }
                                })
                            })
                        }
                        // this.teacher_bord_list =  _.cloneDeep(total_list);
                        this.teacher_bord_list = [...total_list,...bord_list];
                        this.total_bord_num = 10 * res.data.pageCount;
                        this.total_page_count =  res.data.pageCount;
                        this.hide_list_arr =[];
                        this.teacher_bord_list.forEach((item,index)=>{
                            this.hide_list_arr.push(index)
                        })
                    }
                }).catch(err=>console.log(err))
            },
            change_cur_page(val){
                this.curr_page_index = val ;
                this.getTeacherBors();
            },
            //分页加载
            add_page(){
                if(this.curr_page_index>=this.total_page_count){
                    this.$message.info('没有更多了')
                    return;
                }
                this.curr_page_index++;
                this.getTeacherBors()
            },
            //重命名
            edit_name(title,val){
                this.is_edit_name = true;
                this.edit_bord_id = val;
                this.dynamicValidateForm.title = title ;
                this.copy_edit_name = title ;
            },
            //取消修改
            cancel_edit(){
                this.is_edit_name = false;
                this.dynamicValidateForm.title = '';
            },
            //确认提交
            sure_edit(){
                if(this.dynamicValidateForm.title===this.copy_edit_name){
                 // this.$message.warning('当前板书名称没有修改');
                    this.is_edit_name = false;
                    return;
                }
                api.renewName({
                    id:this.edit_bord_id,
                    title:this.dynamicValidateForm.title,
                }).then((res)=>{
                    if(res.errCode==0){
                        this.dynamicValidateForm = {};
                        this.$message.success(res.msg);
                        this.is_edit_name = false;
                        this.$loading.show();
                        this.teacher_bord_list = [];
                        this.getTeacherBors();
                    }
                }).catch(err=>{console.log(err)})
            },
            //修改日期
            change_date(val){
                if(!val){
                    this.select_date = [];
                    this.teacher_bord_list = [];
                    this.curr_page_index = 1;
                    this.getTeacherBors();
                }else{
                    this.teacher_bord_list = [];
                    this.curr_page_index = 1;
                    this.getTeacherBors();

                }
            },
            hide_list(index){
                if(this.hide_list_arr.includes(index)){
                    let list_index = this.hide_list_arr.indexOf(index);
                    this.hide_list_arr.splice(list_index,1)
                }else{
                    this.hide_list_arr.push(index)
                }
            },
            //分享后返回
            sureShareFun(val) {
                this.show_share_hand_write = false;
                this.edit_bord_id = '';
                if(val){
                    this.teacher_bord_list[this.list_index].list[this.cur_img_index].share_range_id = '1';
                }
            },
            getNewDate(month,val){
                this.$loading.show()
                if(month){
                    this.getFileDays(month)
                }else{
                    this.select_date =val?[val]:[];
                    this.$nextTick(()=>{
                        this.teacher_bord_list = [];
                        this.curr_page_index = 1;
                        this.getTeacherBors();
                    })
                }

            },
            //确定选择日期
            sure_date(){
                this.teacher_bord_list = [];
                this.curr_page_index = 1;
                this.getTeacherBors();
            },
            getFileDays(month){
                api.getFileDays({
                    month:month
                }).then((res)=>{
                    if(res.errCode==0){
                        this.file_date = _.cloneDeep(res.data.days);
                        this.$loading.hide()
                    }
                }).catch(err=>{console.log(err)})
            },
        },
        created(){
            // this.getClass();
            // if(sessionStorage.getItem('second_subject')!=""){
            //     this.getTeacherBors()
            // }
        },
        mounted() {
            let timeStamp = parseInt(new Date().getTime() / 1000);
            let month = this.format(timeStamp, "YYYY-MM");
            this.getFileDays(month);
        }
    }
</script>
<style lang="scss">
    .edit-model .el-dialog{
        position: fixed;
        top:50%;
        left:50%;
        margin-top: 0!important;
        transform: translate(-50%,-50%);
    }
</style>
<style scoped lang="scss">

#openAllHandWrite{

}
.dialog-top{
    padding: 0.12rem 0;
    background: #ECEEF5;
}
.save-to-position,.select-hand-write-img{
    margin-bottom:0.1rem;
    >span{
        display: inline-block;
        width:1rem;
        font-size: 0.16rem;
        text-align: right;
        padding-right:0.16rem;
        color:#202020;
        i{
            color:red;
            /*font-size: 0.2rem;*/
            padding-right:0.03rem;
        }
    }
}
.select-hand-write-img{
    height: 3.62rem;
    margin-bottom: 0;
    padding: 0.2rem 0 0 0.16rem;
    overflow: auto;
}
.hand-box{
    position: relative;
    width: 100%;
    padding-left: 0.23rem;
    border-left: 3px solid #DDDFE6;
    /*overflow: hidden;*/
    &::before{
        position: absolute;
        left:-0.1rem;
        top:0.06rem;
        display: inline-block;
        width: 0.16rem;
        height: 0.16rem;
        content:'';
        background: url('~@/assets/images/time_line_ico.svg') no-repeat center center;
        background-size: contain;
    }
    &:first-of-type{
        &::after{
            position: absolute;
            left:-0.1rem;
            top:-9px;
            display: inline-block;
            width: 0.16rem;
            height: 0.16rem;
            content:'';
            background: #fff;
        }
    }
    &:last-of-type{
        /*border: 0 none;*/
        border-color: #fff;
        &::after{
            position: absolute;
            left:-3px;
            top:-9px;
            display: inline-block;
            width: 3px;
            height: 0.16rem;
            content:'';
            background: #DDDFE6;
        }
    }

    p{
        height: 0.3rem;
        line-height: 0.3rem;
        margin-bottom: 0.1rem;
        color:#202020;
        cursor: pointer;
        overflow: hidden;
        span{
            line-height: 0.3rem;
            color:$blueColor;
            cursor: pointer;
        }
        .blue-text{
            margin-left: 0.16rem;
            color:$blueColor;
            vertical-align: middle;
        }
        i{
            display: inline-block;
            width: 0.18rem;
            height: 0.3rem;
            vertical-align: middle;
            &.icon-arrow-up{
                background: url('~@/assets/images/triangle_arrow_gray_up.svg') no-repeat center center;
                background-size: contain;
            }
            &.icon-arrow-down{
                background: url('~@/assets/images/triangle_arrow_gray_down.svg') no-repeat center center;
                background-size: contain;
            }
        }
    }
}
.hand-img-item-box{
    width: 100%;
    overflow: hidden;
}
.hand-write-img{
    display: inline-block;
    /*max-height:4.5rem;*/
    /*width: calc(100% - 1rem);*/
    width: 100%;
    /*overflow: auto;*/
    vertical-align: top;
    &.no-data{
        padding-top: 0.4rem;
        text-align: center;
        font-size: 16px;
        color:#606060;
        font-weight: 500;
    }
    .hand-img-item{
        /*cursor: pointer;*/
        border-radius: 4px;
        border: solid 1px #eeeeee;
        position: relative;
        background: #D5DCE3;
        width: 1.82rem;
        height: 1.18rem;
        margin-right: 0.32rem;
        margin-bottom:0.2rem;
        padding:0.04rem 0.04rem 0rem 0.04rem;
        float: left;
        >span{
            cursor: pointer;
            z-index:1;
            position: absolute;
            top:0.05rem;
            color:#fff;
            padding:0 0.08rem;
            line-height: 0.2rem;
        }
        .share-bord{
            padding: 0 0.04rem;
            font-size: 0.12rem;
            line-height: 0.24rem;
            left:0.04rem;
            background: linear-gradient(313deg, #03B1FE 0%, #047DFE 100%);
            border-radius: 2px;
            i{
                display: inline-block;
                vertical-align: middle;
                font-style: normal;
                margin-left: 0.03rem;
            }
            .is-share{
                display: inline-block;
                width: 0.16rem;
                height: 0.16rem;
                margin-left: 0;
                background: url('~@/assets/images/analysis_subjective_unshare_white_1.svg') no-repeat center;
                background-size: contain;
            }
            .not-share{
                display: inline-block;
                width: 0.16rem;
                height: 0.16rem;
                margin-left: 0;
                background: url('~@/assets/images/analysis_subjective_share_white_1.svg') no-repeat center;
                background-size: contain;
            }
        }
        .del-bord{
            padding: 0 0.05rem;
            font-size: 0.14rem;
            line-height: 0.24rem;
            background-color: #656565;
            border-radius: 2px;
            opacity: 0.6;
            right:0.04rem;
        }
        &.active{
             border-color:#03b4fe;
             @include border_color($blueColor);
         }
    }
    .hand-img-box{
        width: 100%;
        height: 0.74rem;
        background-size: cover;
        background-repeat: no-repeat;
        
        img{
            width: 100%;
            height: 100%;
        }
    }
    .hand-img-info{
        position: absolute;
        bottom:0;
        left:0;
        height: 0.3rem;
        width: 100%;
        line-height: 0.3rem;
        padding: 0 0.08rem;
        font-size: 0.14rem;
        color: #333333;
        background: #fff;
        overflow: hidden;
        span{
            cursor: pointer;
            display: inline-block;
            vertical-align: middle;
            &:first-of-type{
                width: calc(100% - 0.3rem);
                @include textEllipsis;
            }
            &:last-of-type{
                float: right;
                line-height: 0.3rem;
            }
            &.icon-edit{
                width: 0.2rem;
                height: 0.3rem;
                background: url('~@/assets/images/icon_edit_default.svg') no-repeat center;
                background-size: contain;
            }
        }
    }
}

/deep/.el-dialog{
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    margin-top: 0!important;
    border-radius: 4px;
    max-width: 8.46rem;
    min-width: 5rem;
}
.dialog-content-top{
    /*padding: 0.2rem 0.3rem;*/
    /*padding: 0.2rem 0.16rem;*/
    padding: 0.12rem 0.16rem 0.2rem 0.16rem;
}
/deep/.el-dialog__body{
    padding: 0;
}
/deep/.el-dialog__header{

    font-weight: 500;
    color: #202020;
    padding: 0.16rem 0.16rem 0 0.3rem;
}
/deep/.el-dialog__headerbtn .el-dialog__close{
    font-size: 0.18rem;
    font-weight: bold;
}
/deep/.el-pagination{
    color:#777;
}
/deep/.btn-next,/deep/.btn-prev{
    color:#777;
    padding:0 0.1rem;
}
.el-button{
    padding: 0;
    height: 0.4rem;
    width: 0.72rem;
    line-height: 0.38rem;
    font-size: 0.14rem;
    text-align: center;
    vertical-align: middle;
}
.edit-model{
    /deep/.el-dialog{
        padding: 0.2rem 0.3rem;
        width: 5.33rem;
    }
    /deep/.el-dialog__header{
       padding: 0;
    }
    form{
        padding-top: 0.2rem;
    }
    .el-form-item{
        &:last-of-type{
            margin-bottom: 0;
        }
    }
}
.dialog-pagination{
    height:0.3rem;
    line-height: 0.3rem;
    /*line-height: 0.5rem;*/
    /*padding-top:0.1rem;*/
    text-align: center;
    margin-bottom: 0.12rem;
    p{
        display: inline-block;
        text-align: center;
        color:$blueColor;
        line-height: 20px;
        cursor:pointer;
        font-weight: bold;
    }
}
.dialog-bottom{
    text-align: right;
    /*margin-top:0.2rem;*/
    padding: 0.16rem 0.32rem;
    border-top: 1px solid #D3DCE6;
}
.class-list{
    position: relative;
    display: inline-block;
    width: calc(100% - 1rem);
    vertical-align: middle;
    span{
        display: inline-block;
        height: 0.28rem;
        line-height: 0.28rem;
        padding: 0 0.2rem;
        margin-bottom: 0.1rem;
        border-radius: 0.07rem;
        cursor: pointer;
        &.active{
            color:#fff;
            background: $blueColor;
        }
    }
    .date-box{
        position: absolute;
        top:0.42rem;
        left:0;
        width: 3.4rem;
        color: #606266;
        border: 1px solid #e4e7ed;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        background: #fff;
        border-radius: 4px;
        z-index: 3;
    }
}
.dater-select{
    .input-item{
        width: 1.5rem;
    }
}
/deep/.el-select{
    .el-icon-arrow-up::before,.el-icon-arrow-up::before{
        content:'';
    }
    .el-icon-arrow-up{
        content:'';
        background: url('~@/assets/images/triangle_arrow_gray_up.svg') no-repeat center center;
    }
    .el-icon-arrow-up{
        content:'';
        background: url('~@/assets/images/triangle_arrow_gray_down.svg') no-repeat center center;

    }
}
@media (max-height: 950px) {
    .hand-write-img{
        /*max-height: 3rem;*/
    }
}
@media (max-height: 769px) {
    /deep/.el-dialog__body{
        /*padding: 0.1rem 0.3rem;*/
    }
    .dialog-bottom{
        margin-top: 0rem;
    }
    .hand-write-img{
        /*max-height: 2.9rem;*/
    }
}
@media (max-width:1290px) {
    .select-hand-write-img{
        height: 3rem;
    }
    .el-button{
        width: 0.6rem;
        height: 0.32rem;
        line-height: 0.32rem;
    }
}
@media (max-width:1100px) {
    .select-hand-write-img{
        height: 2rem;
    }
}
@media (max-width:980px) {
    .select-hand-write-img{
        height: 1.5rem;
        &.no-data{
            height: 1.5rem;
        }
    }
    .dialog-bottom{
        margin-top: 0;
        padding: 0.1rem 0.32rem;
    }
    .el-button{
        width: 0.6rem;
        height: 0.32rem;
        line-height: 0.3rem;
    }
}
@media (max-width:860px) {

}
</style>
